export default "__VITE_ASSET__a26fc5b3__"